// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"64":"475e1a25","769":"ee4e8261"}[chunkId] + ".chunk.js";
};